async function addToCartWithRetry(variantId, qty, maxRetries = 9, delay = 1500) {
  for (let attempt = 1; attempt <= maxRetries; attempt++) {
    try {
      const addRes = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: variantId, quantity: qty })
      });

      const addData = await addRes.json();

      if (addRes.ok) {
       
        return { success: true, data: addData };
      }

      const isSoldOut = addData?.description?.includes('sold out') ||
                        addData?.description?.includes('All') ||
                        addData?.status === 422;

      if (isSoldOut && attempt < maxRetries) {
       
        await new Promise(r => setTimeout(r, delay));
        continue;
      }

      return { success: false, data: addData };

    } catch (err) {
      if (attempt < maxRetries) {
        await new Promise(r => setTimeout(r, delay));
      } else {
        return { success: false, error: err };
      }
    }
  }
  return { success: false, error: 'Max retries reached' };
}

function updatePriceWithPremium() {
    let priceEl = document.querySelector('.price-item--regular');
    let premiumPercentEl = document.getElementById('premium-charge');
    let premiumCheckbox = document.getElementById('add-premium');

    if (!priceEl) return;

    if (!priceEl.dataset.basePrice) {
        priceEl.dataset.basePrice = parseFloat(
            priceEl.innerText.replace(/[^0-9.]/g, '')
        );
    }

    let basePrice = Number(priceEl.dataset.basePrice);
    let finalPrice = basePrice;

    if (
        premiumCheckbox &&
        premiumCheckbox.classList.contains('active-premium') &&
        premiumPercentEl
    ) {
        let percent = Number(premiumPercentEl.innerText.replace('%', '')) / 100;
        finalPrice = basePrice + (basePrice * percent);
    }

    priceEl.innerText = '$' + finalPrice.toLocaleString('en-US', {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
    });
}

function addDummyCartItem(title, price, variant, imageUrl) {
  const cartItemsTable = document.querySelector('#CartDrawer-CartItems .cart-items tbody');

  if (!cartItemsTable) {
    console.error('Cart items table not found');
    return;
  }

  const img = imageUrl || 'https://hearthsidefurniture.myshopify.com/cdn/shop/files/frame_1321315493_360.png?v=1774520314';

  const dummyRow = document.createElement('tr');
  dummyRow.id = 'CartDrawer-Item-dummy';
  dummyRow.className = 'cart-item generations-storage-bed-twin-cherry-premium';
  dummyRow.role = 'row';
  dummyRow.setAttribute('product-id', 'dummy-' + Date.now());
  dummyRow.setAttribute('variant-id', 'dummy-var-' + Date.now());

  dummyRow.innerHTML = `
    <td class="cart-item__media" role="cell" headers="CartDrawer-ColumnProductImage">
      <a href="javascript:void(0)" class="cart-item__link" tabindex="-1" aria-hidden="true"></a>
      <img class="cart-item__image" src="${img}" alt="" loading="lazy" width="150" height="150">
    </td>
    <td class="cart-item__details" role="cell" headers="CartDrawer-ColumnProduct">
      <a href="javascript:void(0)" class="cart-item__name h4 break">${title}</a>
      <div class="product-option">$ ${parseFloat(price).toFixed(2)}</div>
      <dl>
        <div class="product-option">
          <dt>Title:</dt>
          <dd>${variant}</dd>
        </div>
      </dl>
      <p class="product-option"></p>
      <ul class="discounts list-unstyled" role="list" aria-label="Discount"></ul>
    </td>
    <td class="cart-item__totals right" role="cell" headers="CartDrawer-ColumnTotal">
      <div class="loading__spinner hidden">
        <svg xmlns="http://www.w3.org/2000/svg" class="spinner" viewBox="0 0 66 66"><circle stroke-width="6" cx="33" cy="33" r="30" fill="none" class="path"></circle></svg>
      </div>
      <div class="cart-item__price-wrapper">
        <span class="price price--end">$ ${parseFloat(price).toFixed(2)}</span>
      </div>
    </td>
    <td class="cart-item__quantity" role="cell" headers="CartDrawer-ColumnQuantity">
      <quantity-popover>
        <div class="cart-item__quantity-wrapper quantity-popover-wrapper">
          <div class="quantity-popover-container">
            <quantity-input class="quantity cart-quantity">
              <button class="quantity__button quantity__button--minus" type="button" disabled>
                <span class="visually-hidden">Decrease quantity</span>
                <span class="svg-wrapper"><svg xmlns="http://www.w3.org/2000/svg" fill="none" class="icon icon-minus" viewBox="0 0 10 2"><path fill="currentColor" fill-rule="evenodd" d="M.5 1C.5.7.7.5 1 .5h8a.5.5 0 1 1 0 1H1A.5.5 0 0 1 .5 1" clip-rule="evenodd"></path></svg></span>
              </button>
              <input class="quantity__input" readonly type="number" value="1" aria-label="Quantity">
              <button class="quantity__button quantity__button--plus" type="button" disabled>
                <span class="visually-hidden">Increase quantity</span>
                <span class="svg-wrapper"><svg xmlns="http://www.w3.org/2000/svg" fill="none" class="icon icon-plus" viewBox="0 0 10 10"><path fill="currentColor" fill-rule="evenodd" d="M1 4.51a.5.5 0 0 0 0 1h3.5l.01 3.5a.5.5 0 0 0 1-.01V5.5l3.5-.01a.5.5 0 0 0-.01-1H5.5L5.49.99a.5.5 0 0 0-1 .01v3.5l-3.5.01z" clip-rule="evenodd"></path></svg></span>
              </button>
            </quantity-input>
          </div>
          <cart-remove-button>
            <button type="button" class="button button--tertiary cart-remove-button" disabled>
              <span class="svg-wrapper"><svg xmlns="http://www.w3.org/2000/svg" class="icon icon-remove" viewBox="0 0 16 16"><path fill="currentColor" d="M14 3h-3.53a3.07 3.07 0 0 0-.6-1.65C9.44.82 8.8.5 8 .5s-1.44.32-1.87.85A3.06 3.06 0 0 0 5.53 3H2a.5.5 0 0 0 0 1h1.25v10c0 .28.22.5.5.5h8.5a.5.5 0 0 0 .5-.5V4H14a.5.5 0 0 0 0-1M6.91 1.98c.23-.29.58-.48 1.09-.48s.85.19 1.09.48c.2.24.3.6.36 1.02h-2.9c.05-.42.17-.78.36-1.02m4.84 11.52h-7.5V4h7.5z"></path><path fill="currentColor" d="M6.55 5.25a.5.5 0 0 0-.5.5v6a.5.5 0 0 0 1 0v-6a.5.5 0 0 0-.5-.5m2.9 0a.5.5 0 0 0-.5.5v6a.5.5 0 0 0 1 0v-6a.5.5 0 0 0-.5-.5"></path></svg></span>
            </button>
          </cart-remove-button>
        </div>
      </quantity-popover>
    </td>
  `;

  cartItemsTable.prepend(dummyRow);
}


async function createProduct(title, price, variant, qty) {
  CartLoader.show();
  const cartNotification = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
  const image = 'https://hearthsidefurniture.myshopify.com/cdn/shop/files/frame_1321315493_360.png?v=1774520314';

  try {
    const cartRes = await fetch('/cart.js');
    const cart = await cartRes.json();

    const existingItem = cart.items.find(item => item.title === `${title} - ${variant}`);

    let cartUpdated = false;

    if (existingItem) {
      let freeQty = 0;
      for (const item of cart.items) {
        if ( item.properties?.['Antiquity Finish'] === 'true' ||
  item.properties?.['Old World Distressing'] === 'true') {
          freeQty += item.quantity;
        }
      }
      await fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: existingItem.key, quantity: freeQty })
      });
      cartUpdated = true;

    } else {
      setTimeout(() => addDummyCartItem(title, price, variant, image), 800);

      const res = await fetch(
        'https://dev.hearthsidefurniture.com/api/product-create.php',
        {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ title, price, image, variant, cart })
        }
      );

      const result = await res.json();

      if (result?.success && result.variant_id) {
        const addResult = await addToCartWithRetry(result.variant_id, qty);

        if (!addResult.success) {
          console.error('Add failed after all retries:', addResult);
          return;
        }
        cartUpdated = true;
      }
    }

    if (cartUpdated && cartNotification) {
      const [latestCart, sections] = await Promise.all([
        fetch('/cart.js').then(r => r.json()),
        fetch(`${window.routes.cart_url}?sections=cart-drawer,cart-notification,cart-icon-bubble,header`).then(r => r.json())
      ]);
      cartNotification.renderContents({ items: latestCart.items, sections });
    }

  } catch (err) {
    console.error('createProduct error:', err);
  } finally {
    CartLoader.hide();
  }
}

if (!customElements.get('product-form')) {

  document.getElementById('add-premium')?.addEventListener('click', function () {
    this.classList.toggle('active-premium');
    const isPremiumInput = document.getElementById('ispremium');
    if (this.classList.contains('active-premium')) {
      isPremiumInput.value = 'true';
    } else {
      isPremiumInput.value = '';
    }
    updatePriceWithPremium();
  });

  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();
        this.form = this.querySelector('form');
        this.variantIdInput.disabled = false;
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        this.submitButton = this.querySelector('[type="submit"]');
        this.submitButtonText = this.submitButton.querySelector('span');
        if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');
        this.hideErrors = this.dataset.hideErrors === 'true';
      }

      onSubmitHandler(evt) {
        evt.preventDefault();
        if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

        this.handleErrorMessage();
        this.submitButton.setAttribute('aria-disabled', true);
        this.submitButton.classList.add('loading');
        this.querySelector('.loading__spinner').classList.remove('hidden');

        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];
        const formData = new FormData(this.form);

        if (this.cart) {
          formData.append('sections', this.cart.getSectionsToRender().map((section) => section.id));
          formData.append('sections_url', window.location.pathname);
          this.cart.setActiveElement(document.activeElement);
        }

        document.querySelector('cart-drawer')?.classList.remove('is-empty');
        config.body = formData;

        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              publish(PUB_SUB_EVENTS.cartError, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                errors: response.errors || response.description,
                message: response.message,
              });
              this.handleErrorMessage(response.description);

              const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
              if (!soldOutMessage) return;
              this.submitButton.setAttribute('aria-disabled', true);
              this.submitButtonText.classList.add('hidden');
              soldOutMessage.classList.remove('hidden');
              this.error = true;
              return;
            } else if (!this.cart) {
              window.location = window.routes.cart_url;
              return;
            }

            const startMarker = CartPerformance.createStartingMarker('add:wait-for-subscribers');
            if (!this.error)
              publish(PUB_SUB_EVENTS.cartUpdate, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                cartData: response,
              }).then(() => {
                CartPerformance.measureFromMarker('add:wait-for-subscribers', startMarker);
              });

            this.error = false;
            const quickAddModal = this.closest('quick-add-modal');

            if (quickAddModal) {
              document.body.addEventListener(
                'modalClosed',
                () => {
                  setTimeout(() => {
                    CartPerformance.measure("add:paint-updated-sections", () => {
                      this.cart.renderContents(response);
                    });
                  });
                },
                { once: true }
              );
              quickAddModal.hide(true);
            } else {
              const premiumElements = document.getElementsByClassName('active-premium');
              const isPremium = premiumElements.length > 0;

              if (isPremium) {
                const custom_title = document.getElementById('add-premium').getAttribute('custom-title')
                const cartId = document.getElementById('CartDrawer');
                cartId.classList.add('cart-drawer-loaded');
                const surcharge = Number(document.getElementById('premium-charge').innerText.replace('%', '')) / 100;
                const variantTitle = response.variant_title;
                const ProductTitle = `${response.product_title}-${custom_title}`;
                const ProductQty = response.quantity;
                const ProductPrice = (response.price / 100) * surcharge;
                createProduct(ProductTitle, ProductPrice, variantTitle, ProductQty);
              }

              CartPerformance.measure("add:paint-updated-sections", () => {
                this.cart.renderContents(response);
              });
            }
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            this.submitButton.classList.remove('loading');
            if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
            if (!this.error) this.submitButton.removeAttribute('aria-disabled');
            this.querySelector('.loading__spinner').classList.add('hidden');
            CartPerformance.measureFromEvent("add:user-action", evt);
            
          });
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;
        this.errorMessageWrapper = this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
        if (!this.errorMessageWrapper) return;
        this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');
        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);
        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }

      toggleSubmitButton(disable = true, text) {
        if (disable) {
          this.submitButton.setAttribute('disabled', 'disabled');
          if (text) this.submitButtonText.textContent = text;
        } else {
          this.submitButton.removeAttribute('disabled');
          this.submitButtonText.textContent = window.variantStrings.addToCart;
        }
      }

      get variantIdInput() {
        return this.form.querySelector('[name=id]');
      }
    }
  );
}

if (!customElements.get('product-form')) {
 
document.getElementById('add-premium')?.addEventListener('click', function () {
    this.classList.toggle('active-premium');

    const isPremiumInput = document.getElementById('ispremium');
    if (this.classList.contains('active-premium')) {
        isPremiumInput.value = 'true';
    } else {
        isPremiumInput.value = '';
    }
    updatePriceWithPremium();
});


  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();



        this.form = this.querySelector('form');
        this.variantIdInput.disabled = false;
   
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        this.submitButton = this.querySelector('[type="submit"]');
        this.submitButtonText = this.submitButton.querySelector('span');

        if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');

        this.hideErrors = this.dataset.hideErrors === 'true';
      }

      onSubmitHandler(evt) {
        evt.preventDefault();
        if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

        this.handleErrorMessage();
        

        this.submitButton.setAttribute('aria-disabled', true);
        this.submitButton.classList.add('loading');
        this.querySelector('.loading__spinner').classList.remove('hidden');

        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];
        const formData = new FormData(this.form);
        
        if (this.cart) {
          formData.append(
            'sections',
            this.cart.getSectionsToRender().map((section) => section.id)
          );
          formData.append('sections_url', window.location.pathname);
          this.cart.setActiveElement(document.activeElement);
        }
        document.querySelector('cart-drawer')?.classList.remove('is-empty');
        config.body = formData;

        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              publish(PUB_SUB_EVENTS.cartError, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                errors: response.errors || response.description,
                message: response.message,
              });
              this.handleErrorMessage(response.description);

              const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
              if (!soldOutMessage) return;
              this.submitButton.setAttribute('aria-disabled', true);
              this.submitButtonText.classList.add('hidden');
              soldOutMessage.classList.remove('hidden');
              this.error = true;
              return;
            } else if (!this.cart) {
              window.location = window.routes.cart_url;
              return;
            }

            const startMarker = CartPerformance.createStartingMarker('add:wait-for-subscribers');
            if (!this.error)
              publish(PUB_SUB_EVENTS.cartUpdate, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                cartData: response,
              }).then(() => {
                CartPerformance.measureFromMarker('add:wait-for-subscribers', startMarker);
              });
            this.error = false;
            const quickAddModal = this.closest('quick-add-modal');
            if (quickAddModal) {
              document.body.addEventListener(
                'modalClosed',
                () => {
                  setTimeout(() => {
                    CartPerformance.measure("add:paint-updated-sections", () => {
                      this.cart.renderContents(response);
                    });
                  });
                },
                { once: true }
              );
              quickAddModal.hide(true);
            } else {
              
              const premiumElements = document.getElementsByClassName('active-premium');
              const isPremium = premiumElements.length > 0;
              
              if(isPremium){
                const cartId = document.getElementById('CartDrawer');
              cartId.classList.add('cart-drawer-loaded');
              const surcharge = Number(document.getElementById('premium-charge').innerText.replace('%',''))/100;
             const variantTitle = response.variant_title;
              const ProductTitle = `${response.product_title}-premium`;
              const ProductQty = response.quantity;
              const ProductPrice =  (response.price / 100) * surcharge;
             
              createProduct(ProductTitle,ProductPrice,variantTitle,ProductQty);
             
              }
              
                CartPerformance.measure("add:paint-updated-sections", () => {
                this.cart.renderContents(response);
              });

            

              
             
            }
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
           
              this.submitButton.classList.remove('loading');
            if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
            if (!this.error) this.submitButton.removeAttribute('aria-disabled');
            this.querySelector('.loading__spinner').classList.add('hidden');

            CartPerformance.measureFromEvent("add:user-action", evt);
           

          
           
          });
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
        if (!this.errorMessageWrapper) return;
        this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }

      toggleSubmitButton(disable = true, text) {
        if (disable) {
          this.submitButton.setAttribute('disabled', 'disabled');
          if (text) this.submitButtonText.textContent = text;
        } else {
          this.submitButton.removeAttribute('disabled');
          this.submitButtonText.textContent = window.variantStrings.addToCart;
        }
      }

      get variantIdInput() {
        return this.form.querySelector('[name=id]');
      }
    }
  );
}
